import React, { useState, useEffect } from 'react';
import Appearance from 'styles/Appearance.js';
import Utils from 'files/Utils.js';
import SectionHeader from 'views/SectionHeader.js';

const gallery = [
    { src: '/images/water-sensor-back-white.jpg', alt: 'Water Sensor' },
    { src: '/images/bedside-control-center-front-white.jpg', alt: 'Bedside Control Center' },
    { src: '/images/comm-link-front-white.jpg', alt: 'Smart Hub' },
];

const About = () => {

    const [active, setActive] = useState(0);
    const [autoplay, setAutoplay] = useState(true);

    // Auto-cycle the product gallery until the visitor takes control.
    useEffect(() => {
        if(!autoplay) {
            return;
        }
        const id = setInterval(() => {
            setActive(prev => (prev + 1) % gallery.length);
        }, 3500);
        return () => clearInterval(id);
    }, [autoplay]);

    return (
        <section id={'about'} style={{
            width: '100%',
            backgroundColor: Appearance.colors.offWhite,
        }}>
            <div style={{
                maxWidth: Appearance.layout.maxWidth,
                margin: '0 auto',
                padding: Appearance.layout.sectionPadding(),
            }}>
                {/* Section Title */}
                <SectionHeader
                    eyebrow={'Our Mission'}
                    title={<>{'Protecting Boldly, Alerting Instantly.'}<br />{'Crafted for Those Who Never Settle.'}</>} />

                {/* Content Grid */}
                <div style={{
                    display: 'grid',
                    gridTemplateColumns: Utils.isMobile() ? '1fr' : '1fr 1fr',
                    gap: Utils.isMobile() ? 30 : 60,
                    alignItems: 'center',
                }}>
                    {/* Left — Product showcase / image area */}
                    <div style={{
                        display: 'flex',
                        flexDirection: 'column',
                        alignItems: 'center',
                        gap: 20,
                    }}>
                        {/* Main product visual — reflects the selected thumbnail */}
                        <div style={{
                            width: '100%',
                            maxWidth: 400,
                            height: 300,
                            borderRadius: 24,
                            backgroundColor: Appearance.colors.white,
                            border: `1px solid ${Appearance.colors.border()}`,
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            position: 'relative',
                            overflow: 'hidden'
                        }}>
                            {gallery.map((item, index) => (
                                <img key={index}
                                    src={item.src}
                                    alt={item.alt}
                                    style={{
                                        position: 'absolute',
                                        top: 0,
                                        left: 0,
                                        width: '100%',
                                        height: '100%',
                                        objectFit: 'cover',
                                        opacity: index === active ? 1 : 0,
                                        transition: 'opacity 0.5s ease',
                                    }} />
                            ))}
                        </div>

                        {/* Product thumbnails — click to swap the main image */}
                        <div style={{
                            display: 'flex',
                            gap: 12,
                        }}>
                            {gallery.map((item, index) => {
                                const isActive = index === active;
                                return (
                                    <div key={index}
                                        onClick={() => { setActive(index); setAutoplay(false); }}
                                        title={item.alt}
                                        style={{
                                            width: 95,
                                            height: 72,
                                            borderRadius: 14,
                                            backgroundColor: Appearance.colors.white,
                                            display: 'flex',
                                            alignItems: 'center',
                                            justifyContent: 'center',
                                            border: `1px solid ${isActive ? Appearance.colors.primary() : Appearance.colors.border()}`,
                                            boxShadow: isActive ? `0 0 0 2px ${Utils.hexToRGBA(Appearance.colors.primary(), 0.35)}` : 'none',
                                            overflow: 'hidden',
                                            cursor: 'pointer',
                                            opacity: isActive ? 1 : 0.7,
                                            transition: 'all 0.15s ease',
                                        }}>
                                        <img src={item.src} alt={item.alt} style={{ width: '100%', height: '100%', objectFit: 'cover' }} />
                                    </div>
                                );
                            })}
                        </div>
                    </div>

                    {/* Right — Text Content */}
                    <div>
                        <p style={{
                            ...Appearance.textStyles.body(),
                            marginBottom: 24,
                        }}>
                            {'At Aqua Link, we believe home safety should be pure, strong, and uncompromising. That\'s why we develop innovative sensors and alert systems for all situations, delivering a constant and dependable safety experience.'}
                        </p>
                        <p style={{
                            ...Appearance.textStyles.body(),
                            marginBottom: 32,
                        }}>
                            {'Whether you\'re a renter, homeowner, or building manager, our products provide a shield of trust you can rely on without all the complexity and noise.'}
                        </p>

                        {/* Highlight Cards */}
                        <div style={{
                            display: 'flex',
                            flexDirection: 'column',
                            gap: 16,
                        }}>
                            {[
                                { icon: 'fas fa-check-circle', text: 'Plug-and-play setup' },
                                { icon: 'fas fa-check-circle', text: 'Dual Ethernet and WiFi connectivity' },
                                { icon: 'fas fa-check-circle', text: 'Works with all Aqua Link devices seamlessly' },
                            ].map((item, index) => (
                                <div key={index} style={{
                                    display: 'flex',
                                    alignItems: 'center',
                                    gap: 12,
                                }}>
                                    <i className={item.icon} style={{
                                        fontSize: 18,
                                        color: Appearance.colors.primary(),
                                    }} />
                                    <span style={Appearance.textStyles.body({ color: Appearance.colors.text(), fontWeight: 500 })}>
                                        {item.text}
                                    </span>
                                </div>
                            ))}
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default About;
